import { useEffect, useState } from 'react'
import axios from 'axios'
import { ErrorPage } from "../ErrorPage"
import { LoadingPage } from '../LoadingPage'
import ClientLogo from '../../components/ClientLogo';
import * as G from '../../theme/global-styles';
import * as S from './styles';
import { ThemedButton } from '../../components/ThemedButton';
import PoweredByQITech from '../../components/PoweredByQITech';
import { DataDisplayDescription } from '../PersonalDocument/styles';
import { Wallpaper } from '../../components/Wallpaper';
import { Box } from '@mui/material';
import Logo from '../../components/Logo';
import Button from '../../components/Button';
import { Footer } from '../../components/Footer';
import { Checkbox } from '@mui/material';
import { useThemeContext } from "../../contexts/ThemeContext";
import { getOrCreateBrowserKey } from '../../utils/fingerprint_utils'

export const ResumeOperation = (props) => {
    const { clientThemeSettings } = useThemeContext();

    const { signData, setSignerStep, setSignData, appTheme } = props
    const initialError = {"has_error": false, "status": 0}

    const [error, setError] = useState({})
    const [loading, setLoading] = useState(true)
    const [hasMadeRequest, setHasMadeRequest] = useState(false)
    const [isChecked, setIsChecked] = useState(false)

    const handleCheckboxChange = (event) => {
      setIsChecked(event.target.checked)
    };

    function formatDate(inputDate) {
        const date = new Date(inputDate)
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
      
        return `${day}/${month}/${year}`
      }

    useEffect(() => {
        setLoading(false)
    }, [])

    if (loading) {
        return (
            <LoadingPage clientThemeSettings={clientThemeSettings} />
        )
    }

    const handleClick = async () => {

        if (hasMadeRequest) {
            return  
        }
        let browserKey = null;
        try{
            browserKey = await getOrCreateBrowserKey();
        } catch(err) {
        }
        const payload = {
            "step": "resume_operation",
            "event_date": new Date().toISOString(),
            "device_data": {
                "device_key": browserKey
            }
        }
    
        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }
    
        setLoading(true)
        setHasMadeRequest(true)

        axios.patch('/signer', payload, config)
        .then(response => {
            setSignerStep(response.data.next_step)
            setSignData({ ...signData, ...response.data })
        })
        .catch((error) => {
            if ([401, 403, 409].includes((error.response || {}).status)) {
                setError({
                    "has_error": true,
                    "status": error.response.status
                })
            } else {
                setError({
                    "has_error": true,
                    "status": 500
                })
            }

            setHasMadeRequest(false)
        })
        .finally(() => {
            setLoading(false)
        })
    }


    const formatCurrency = (value) => {
        const valueInReais = value / 100;
    
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(valueInReais);
      };


    const renderInsurance = () => {
        let notShowInsurance = ['internal_account', 'intelligent_pix'].includes(signData.credit_operation_data?.insurance?.payment_type || '')
        
        if(notShowInsurance) 
            return <></>

        if (signData.credit_operation_data?.insurance){
            <S.Data>
                <S.DataLabel>Seguro:</S.DataLabel>
                <S.DataValue>Sim</S.DataValue>
            </S.Data>
        } else {
            return <S.Data>
                <S.DataLabel>Seguro:</S.DataLabel>
                <S.DataValue>Não</S.DataValue>
            </S.Data>
        }

        return <></>
    }

    if (appTheme === 'release') {
        return (
            <G.Container style={{padding: "16px 0"}}>
                <ClientLogo clientThemeSettings={clientThemeSettings} size="small" />
                <S.TermContainer>
                    <G.Title>Resumo do contrato</G.Title>
                    <S.Divider/>
                    <S.Data>
                        <S.DataLabel>Valor a receber:</S.DataLabel>
                        <S.DataValue>{formatCurrency(signData.credit_operation_data.disbursed_amount)}</S.DataValue>
                    </S.Data>
                    <S.Divider/>
                    <S.Data>
                        <S.DataLabel>Valor total financiado:</S.DataLabel>
                        <S.DataValue>{formatCurrency(signData.credit_operation_data.issue_amount)}</S.DataValue>
                    </S.Data>
                    <S.Data>
                        <S.DataLabel>CET (a.m):</S.DataLabel>
                        <S.DataValue>{signData.credit_operation_data.monthly_cet} % ao mês</S.DataValue>
                    </S.Data>
                    {
                        signData.credit_operation_data?.tac && <S.Data>
                            <S.DataLabel>TAC:</S.DataLabel>
                            <S.DataValue>{formatCurrency(signData.credit_operation_data.tac)}</S.DataValue>
                        </S.Data>
                    }
                    <S.Divider/>
                    <S.Data>
                        <S.DataLabel>Data da primeira parcela:</S.DataLabel>
                        <S.DataValue>{formatDate(signData.credit_operation_data.first_due_date)}</S.DataValue>
                    </S.Data>
                    <S.Data>
                        <S.DataLabel>Taxa de juros mensal:</S.DataLabel>
                        <S.DataValue>{signData.credit_operation_data.monthly_interest_rate} %</S.DataValue>
                    </S.Data>
                    <S.Data>
                        <S.DataLabel>IOF:</S.DataLabel>
                        <S.DataValue>{formatCurrency(signData.credit_operation_data.iof)}</S.DataValue>
                    </S.Data>
                    {renderInsurance()}
                    <S.Divider/>
                    <S.Data>
                        <S.DataLabel>Beneficiário:</S.DataLabel>
                        <S.DataValue>{signData.credit_operation_data.borrower.name}</S.DataValue>
                    </S.Data>
                    <S.Data>
                        <S.DataLabel>CPF:</S.DataLabel>
                        <S.DataValue>{signData.credit_operation_data.borrower.document_number}</S.DataValue>
                    </S.Data>
                </S.TermContainer>
                {error.has_error &&
                    <ErrorPage
                        error={error}
                        redirectToLogin={() => setSignerStep("login")}
                        resetError={() => setError(initialError)}
                        clientThemeSettings={clientThemeSettings}
                    />
                }
                <S.Footer>
                    <S.CheckboxContainer>
                        <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
                        <S.CheckboxLabel>
                            Declaro que li e estou de acordo com as condições do contrato acima.
                        </S.CheckboxLabel>
                    </S.CheckboxContainer>
                    <ThemedButton
                        clientThemeSettings={clientThemeSettings}
                        loading={false}
                        onClick={handleClick}
                        disabled={!isChecked}
                    >
                        Aceitar termos do contrato
                    </ThemedButton>
                    <PoweredByQITech />
                </S.Footer>
            </G.Container>
        );
    }
    
    return (
        <Wallpaper backgroundColor={clientThemeSettings["background_color"]} style={{ padding: '10px' }}>
            <Box className="base-container base-container-width base-container-padding" style={{ backgroundColor: "rgb(245, 245, 242)", marginBottom: "180px" }}>
                <Logo imageSource={clientThemeSettings.logo_url} />
                <Box style={{width: '95%'}}>
                    {(
                        <Box>
                            <DataDisplayDescription style={{textAlign: "center"}}><b>Resumo do contrato</b></DataDisplayDescription>
                            <Box style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', width: '100%' }}>
                            <Box className="box-display-container">

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    Valor a receber:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                    <b>{formatCurrency(signData.credit_operation_data.disbursed_amount)}</b>
                                    </DataDisplayDescription>
                                </Box>

                                {/* <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    Parcelas:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                    <b>{signData.credit_operation_data.number_of_installments}x de R$ NAO TEMOS O VALOR</b>
                                    </DataDisplayDescription>
                                </Box> */}


                            </Box>
                            <Box className="box-display-container">

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                        Valor total financiado:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                        <b>{formatCurrency(signData.credit_operation_data.issue_amount)}</b>
                                    </DataDisplayDescription>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                        CET (a.m):
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                        <b>{signData.credit_operation_data.monthly_cet} % ao mês</b>
                                    </DataDisplayDescription>
                                </Box>

                            </Box>
                            <Box className="box-display-container">

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    Data da primeira parcela:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                        <b>{formatDate(signData.credit_operation_data.first_due_date)}</b>
                                    </DataDisplayDescription>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                        Taxa de juros mensal:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                        <b>{signData.credit_operation_data.monthly_interest_rate} %</b>
                                    </DataDisplayDescription>
                                </Box>

                                {/* <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    Taxa de juros anual:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                        <b>NAO TEMOS O VALOR AO ANO %</b>
                                    </DataDisplayDescription>
                                </Box> */}

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    IOF:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                    <b>{formatCurrency(signData.credit_operation_data.iof)}</b>
                                    </DataDisplayDescription>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    Seguro:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                    <b>{signData.credit_operation_data.insurance ? "SIM" : "NÃO"}</b>
                                    </DataDisplayDescription>
                                </Box>

                            </Box>
                            <Box className="box-display-container">

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    Beneficiário:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                    <b>{signData.credit_operation_data.borrower.name}</b>
                                    </DataDisplayDescription>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <DataDisplayDescription style={{ flex: 1 }}>
                                    CPF:
                                    </DataDisplayDescription>
                                    <DataDisplayDescription style={{ textAlign: 'right' }}>
                                    <b>{signData.credit_operation_data.borrower.document_number}</b>
                                    </DataDisplayDescription>
                                </Box>

                            </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>
            {error.has_error &&
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerStep("login")}
                    resetError={() => setError(initialError)}
                    clientThemeSettings={clientThemeSettings}
                />
            }
                <Box
                        style={{
                            position: "fixed",
                            bottom: 0,
                            width: "100%",
                            alignItems: "center",
                            textAlign: "center",
                            backgroundColor: "#f9f9f9",
                            padding: "10px 15px",
                            borderTop: "1px solid #ccc"
                        }}
                    >
                        {/* <FormControlLabel
                            control={
                            <Checkbox
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                color="primary"
                            />
                            }
                            label="Declaro que li e aceito que o valor do seguro será incluído no contrato."
                        /> */}
                        <Box style={{ display: "flex", alignItems: "left", justifyContent: "left", textAlign: "left", padding: "10px"}}>
                                <DataDisplayDescription className="description-level4" style={{ marginRight: "5px", marginLeft: "10px" }}>
                                <b>Declaro que li e estou de acordo com as condições do contrato acima.</b>
                                </DataDisplayDescription>
                                <Checkbox
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                color="primary"
                                style={{marginRight: "10px"}}
                                />
                        </Box>
                        <Button
                            onClick={handleClick}
                            type="primary"
                            disabled={!isChecked}
                            clientThemeSettings={clientThemeSettings}

                        >
                            Aceitar termos do contrato
                        </Button>
                        <Footer />
                </Box>
        </Wallpaper>
    )
};